/**
 * Session dismiss IDs for dashboard strip + notification bell (same scope).
 * Dispatches a same-tab event so all hook instances stay in sync.
 */

export const DASHBOARD_ALERTS_DISMISS_KEY = 'dashboard.dismissedAlerts.session.v1'

export const DASHBOARD_DISMISS_STORAGE_EVENT = 'dashboard-dismissed-alerts-v1'

export function readDashboardDismissedIds(): Set<string> {
  try {
    const raw = sessionStorage.getItem(DASHBOARD_ALERTS_DISMISS_KEY)
    if (!raw) return new Set()
    const arr = JSON.parse(raw) as unknown
    if (!Array.isArray(arr)) return new Set()
    return new Set(arr.filter((x): x is string => typeof x === 'string'))
  } catch {
    return new Set()
  }
}

export function persistDashboardDismissedIds(ids: Set<string>): void {
  try {
    sessionStorage.setItem(DASHBOARD_ALERTS_DISMISS_KEY, JSON.stringify([...ids]))
    window.dispatchEvent(new Event(DASHBOARD_DISMISS_STORAGE_EVENT))
  } catch {
    /* ignore */
  }
}

export function subscribeDashboardDismissed(onStoreChange: () => void): () => void {
  const handler = () => onStoreChange()
  window.addEventListener(DASHBOARD_DISMISS_STORAGE_EVENT, handler)
  window.addEventListener('storage', handler)
  return () => {
    window.removeEventListener(DASHBOARD_DISMISS_STORAGE_EVENT, handler)
    window.removeEventListener('storage', handler)
  }
}

export function getDashboardDismissedSnapshot(): string {
  if (typeof sessionStorage === 'undefined') return '[]'
  return sessionStorage.getItem(DASHBOARD_ALERTS_DISMISS_KEY) ?? '[]'
}

export function parseDashboardDismissedSnapshot(raw: string): Set<string> {
  try {
    const arr = JSON.parse(raw) as unknown
    if (!Array.isArray(arr)) return new Set()
    return new Set(arr.filter((x): x is string => typeof x === 'string'))
  } catch {
    return new Set()
  }
}
